const integrationsQueryKeys = {
  list: () => [
    "integration-list"
  ],
  mirrorRegistryItem: (id) => [
    "mirrorRegistryItem",
    id
  ],
  integrationByExternalId: (externalId) => [
    "integrationByExternalId",
    externalId
  ]
};

export { integrationsQueryKeys };
//# sourceMappingURL=integrationsQueryKeys.js.map
